import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNav from './SideNav';
import { useUser } from '../../contexts/UserContext';
import { useOrganization } from '../../contexts/OrganizationContext';

function Layout({ children }) {
  const { id: currentUserId } = useUser();
  const { currentContext, organizations, setOrganizationContext, isAdmin, isManager } = useOrganization();
  const isLoggedIn = currentUserId != null;
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);

  const handleAccountChange = async (value) => {
    const orgId = value === 'individual' ? null : value;
    await setOrganizationContext(orgId);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* TEMPORARILY HIDDEN: org selector top nav
      {isLoggedIn && (
        <div className={`fixed top-0 ${isNavCollapsed ? 'left-16' : 'left-64'} right-0 bg-white border-b border-gray-200 z-10`}>
          <div className="px-4 py-2">
            <select
              value={currentContext.organization_id || 'individual'}
              onChange={(e) => handleAccountChange(e.target.value)}
              className="block w-48 px-3 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
            >
              <option value="individual">Individual Account</option>
              {organizations.map(org => (
                <option key={org.id} value={org.id}>
                  {org.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      */}
      
      <SideNav 
        isCollapsed={isNavCollapsed}
        setIsCollapsed={setIsNavCollapsed}
        showLifeROI={!currentContext.organization_id}
        showDepartments={currentContext.organization_id && (isAdmin || isManager)}
      />
      
      <main className={`${isNavCollapsed ? 'ml-16' : 'ml-64'} transition-all duration-300 flex flex-col min-h-screen`}>
        <div className="px-6 py-8 flex-1">
          {children}
        </div>
        <footer className="px-6 py-4 border-t border-gray-200 text-sm text-gray-500 flex gap-4">
          <a href="/privacy-policy" className="hover:text-gray-700">Privacy Policy</a>
          <a href="/tos" className="hover:text-gray-700">Terms of Service</a>
        </footer>
      </main>
    </div>
  );
}

export default Layout; 